









































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class ShowAllNotesModal extends Vue {
  protected close(): void {
    this.$emit("close");
  }
}
